import holidayService from "../services/holidayService";
import { useMutation } from "react-query";

const useGetHoliday = (onData) => {
  return useMutation(holidayService.getHoliday, {
    onSuccess: (data) => onData(data),
  });
};

const useCreateHoliday = (onData) => {
  return useMutation(holidayService.createHoliday, {
    onSuccess: (data) => onData(data),
  });
};

const useUpdateHoliday = (onData) => {
  return useMutation(holidayService.updatedHoliday, {
    onSuccess: (data) => onData(data),
  });
};

const useDeleteHoliday = (onData) => {
  return useMutation(holidayService.deleteHoliday, {
    onSuccess: (data) => onData(data),
  });
};

const holidayQueries = {
  useGetHoliday,
  useCreateHoliday,
  useUpdateHoliday,
  useDeleteHoliday
};

export default holidayQueries;
